<template>
    <span>
        <b-button-group class="float-right">
            <b-button
                variant="primary"
                @click="abrirModal()"
                v-if="$temAcessoView('CONT-PAG-01')"
                ><i class="fa fa-plus"></i> Novo Registro de Pagamento</b-button
            >
        </b-button-group>
        <b-modal v-model="mostrarModal" @show="obterFornecedores()" size="lg">
            <div slot="modal-title">
                Novo Registro de Pagamento - Selecione o fornecedor e contrato
            </div>
            <app-erros-box
                :erros="erros"
                v-if="erros.length > 0"
            ></app-erros-box>
            <b-row>
                <b-col sm="12">
                    <b-form-group>
                        <label>Fornecedor</label>
                        <model-list-select
                            :list="fornecedores"
                            option-text="cnpjNome"
                            option-value="codFornecedor"
                            v-model="codFornecedor"
                            @input="$v.codFornecedor.$touch()"
                        >
                        </model-list-select>
                    </b-form-group>
                </b-col>
            </b-row>
            <b-row>
                <b-col sm="12">
                    <b-form-group>
                        <label>Contrato</label>
                        <b-form-select
                            :plain="true"
                            :options="contratos"
                            v-model="contrato"
                            text-field="contrato"
                            value-field="codContrato"
                        ></b-form-select>
                        <!-- <model-list-select
                            :list="contratos"
                            option-text="contrato"
                            option-value="codContrato"
                            v-model="contrato"
                            @input="$v.contrato.$touch()"
                        >
                        </model-list-select> -->
                    </b-form-group>
                </b-col>
            </b-row>
            <div slot="modal-footer">
                <b-button variant="secondary" @click.stop="fecharModal()"
                    >Cancelar</b-button
                >
                <b-button
                    variant="primary"
                    :disabled="$v.$invalid"
                    @click.stop="confirmarNovoPagamento()"
                    class="ml-2"
                >
                    <span> <i class="fa fa-check-circle"></i> Selecionar</span>
                </b-button>
            </div>
        </b-modal>
    </span>
</template>

<script>
import { required } from 'vuelidate/lib/validators'
import { ModelListSelect } from 'vue-search-select'

export default {
    components: {
        ModelListSelect
    },

    props: {
        pagamentosServicos: {
            type: Object,
            default: () => ({})
        }
    },

    data() {
        return {
            mostrarModal: false,
            erros: [],
            codFornecedor: '',
            contrato: '',
            fornecedores: [],
            contratos: []
        }
    },

    methods: {
        abrirModal() {
            this.codFornecedor = null
            this.contrato = ''
            this.mostrarModal = true
        },

        fecharModal() {
            this.mostrarModal = false
            this.contrato = ''
            this.codFornecedor = ''
            this.contratos = []
            this.fornecedores = []
        },

        obterFornecedores() {
            this.$store.dispatch('addRequest')
            this.pagamentosServicos.obterFornecedores().then(response => {
                if (response) {
                    if (response.success) {
                        this.fornecedores = response.data
                        this.contratos = []
                        this.contrato = ''
                    } else {
                        this.$toast.error(
                            response.errors[0],
                            'ERROR',
                            this.error
                        )
                    }
                }
                this.$store.dispatch('removeRequest')
            })
        },

        obterFornecedoresContratos() {
            this.$store.dispatch('addRequest')
            this.pagamentosServicos
                .obterFornecedoresContratos(this.codFornecedor)
                .then(response => {
                    if (response) {
                        if (response.success) {
                            // this.contratos = response.data
                            this.contratos = response.data.map(item => {
                                return { codContrato: item, contrato: item }
                            })
                            this.contrato = ''
                        } else {
                            this.$toast.error(
                                response.errors[0],
                                'ERROR',
                                this.error
                            )
                        }
                    }
                    this.$store.dispatch('removeRequest')
                })
        },

        inserirPagamento() {
            this.$store.dispatch('addRequest')
            this.pagamentosServicos
                .inserirPagamento({
                    codFornecedor: this.codFornecedor,
                    contrato: this.contrato
                })
                .then(response => {
                    if (response) {
                        if (response.success) {
                            this.fecharModal()
                            let pagamentoId = response.data
                            this.$store.dispatch('setRecarregar', true)
                            this.$emit('detalharPagamento', pagamentoId)
                        } else {
                            this.$toast.error(
                                response.errors[0],
                                'ERROR',
                                this.error
                            )
                        }
                    }
                    this.$store.dispatch('removeRequest')
                })
        },

        confirmarNovoPagamento() {
            let fornecedor = this.fornecedores.find(
                p => p.codFornecedor == this.codFornecedor
            )
            this.$swal({
                title: 'Novo Pagamento',
                html: `Confirma a criação de um novo protocolo de pagamento para o fornecedor ${fornecedor.cnpjNome} e contrato ${this.contrato}?`,
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Sim',
                cancelButtonText: 'Não'
            }).then(result => {
                if (result.value) {
                    this.inserirPagamento()
                }
            })
        }
    },

    validations: {
        codFornecedor: {
            required
        },
        contrato: {
            required
        }
    },

    watch: {
        codFornecedor() {
            if (this.codFornecedor) {
                this.obterFornecedoresContratos()
            }
        }
    }
}
</script>
